import React, {Component} from "react";
import {networkDeviceService} from "../../../services/network-device.service";
import {withNamespaces} from "react-i18next";
import {Alert, Button, Spinner, Tab, Tabs} from "react-bootstrap";
import ConnectionStatus from "../../ConnectionStatus";
import ButtonCopy from "../../ButtonCopy";
import DeviceTypeIcon from "../../DeviceTypeIcon";
import axios from "axios";
import { saveAs } from 'file-saver';
import SimpleConnectionStatus from "../../SimpleConnectionStatus";
import Moment from "react-moment";

class DeviceInfoModal extends Component {

    state = {
        networkDevice: null,
        versionsList: null,
        selectedVersion: null,
        screenShot: null,
        versionIsChanges: false,
        crestronCommand: "",
    };

    getNetworkDevice = async () => {
        const { networkDeviceModel } = this.props;
        const res = await networkDeviceService.getItemById(networkDeviceModel.id);
        this.setState(prevState => ({
            ...prevState,
            selectedVersion: res.hiLightSoftwareVersion,
            networkDevice: res
        }))
    }

    getSoftwareVersions = async () => {{
        const res = await networkDeviceService.getSoftwareVersions();
        this.setState(prevState => ({
            ...prevState,
            versionsList: res
        }))
    }}

    async componentDidMount() {
        await this.getNetworkDevice()
        await this.getSoftwareVersions();
    }

    handleOnClickScreenShot = () => {
        axios.get(`/api/networkdevices/screenshot/${this.state.networkDevice.id}`, { responseType: "blob" })
            .then( (res) => {
                this.setState({
                    ...this.state,
                    screenShot: res.data
                })
            });
    };

    handleDownloadScreenShow = () => {
        saveAs(this.state.screenShot, `screenshot-${this.state.networkDevice.label}.jpg`)
    };

    handleOpenFullScreen = () => {
        window.open(`/api/networkdevices/screenshot/${this.state.networkDevice.id}`, "_blank");
    };

    handleOnChangeVersion = (e) => {
        this.setState({
            ...this.state,
            versionIsChanges: true,
            selectedVersion: e.target.value
        });
    }

    handleButtonUpdate = (e) => {
        const { closeModal } = this.props;
        e.preventDefault();
        networkDeviceService.updateSoftForDevice(this.state.networkDevice.id, this.state.selectedVersion)
            .then(
                () => { closeModal() },
                (error) => { console.log(error) }
            )
    }

    handleInputCrestronCommand = (e) => {
        this.setState({
            ...this.state,
            crestronCommand: e.target.value
        })
    }

    handleButtonSendCommandCrestron = () => {
        const model = {
            LogMessage: "test command",
            Time:"00:00:00",
            Type:"Crestron",
            Command: this.state.crestronCommand,
        }
    }

    isDeviceTypeLabel = (label) => {
        const {networkDevice} = this.state;
        return (
            networkDevice?.deviceType.label.toLowerCase().includes(label)
        );
    }

    render() {
        const { t, closeModal } = this.props;
        const { networkDevice, screenShot, versionsList, selectedVersion, versionIsChanges } = this.state;

        let networkDetails = null;
        let errors = null;

        if(networkDevice?.networkDeviceDetails) {
            networkDetails = networkDevice.networkDeviceDetails;

            if(networkDetails?.errors) {
                errors = JSON.parse(networkDetails.errors);
            }
        }

        return (
            <div className="modal-content">
                { networkDevice ? (
                    <div>
                        <div className="modal-header">
                            <div className="modal-title">
                                <h5>{t('network-device-single')} / {networkDevice.label} </h5>
                                <p>{networkDevice.description}</p>
                            </div>
                            <button type="button" className="close" aria-label="Close" onClick={closeModal}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <Tabs defaultActiveKey="home" className="device-info" id="uncontrolled-tab-example">
                                {/*details template*/}
                                <Tab eventKey="home" title={t('device-tab-details')}>
                                    <div className="col-md-12 my-2">
                                        <div className="row align-items-center justify-content-around">
                                            <div className="mx-3">
                                                <DeviceTypeIcon customClass="fa-5x" type={networkDevice.deviceType.label } />
                                            </div>
                                            <div>
                                                <table className="table table-sm table-borderless">
                                                    <tbody>
                                                    <tr>
                                                        <th scope="col">{t('type')}</th>
                                                        <td>{ networkDevice.deviceType.label }</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col">{t('ip-address')}</th>
                                                        <td>{ networkDevice.ipAddress } </td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col">{t('port')}</th>
                                                        <td>{ networkDevice.port }</td>
                                                    </tr>
                                                    {   networkDevice?.deviceType.label === 'PC' ||
                                                        networkDevice?.deviceType.label === 'PC Linux' ||
                                                        networkDevice?.deviceType.label.toLowerCase().includes('nec') ||
                                                        networkDevice?.deviceType.label.toLowerCase().includes('optoma') ||
                                                        networkDevice?.deviceType.label.toLowerCase().includes('pjlink') ||
                                                        networkDevice?.deviceType.label.toLowerCase().includes('android') ? (
                                                        <tr>
                                                            <th scope="col">{t('status-hilight')}</th>
                                                            <td><SimpleConnectionStatus status={networkDevice.isOnline}/></td>
                                                        </tr>
                                                    ) : (
                                                        <React.Fragment/>
                                                    ) }
                                                    <tr>
                                                        <th scope="col">{t('status-network')}</th>
                                                        <td><SimpleConnectionStatus status={networkDevice.isOnlineNetwork}/></td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col">{t('diagnostic-mode')}</th>
                                                        <td>{networkDevice.diagnosticMode ? t('on') : t('off')} </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div>
                                                <div className="flex-column my-2">
                                                    <ButtonCopy fullWidth={true} buttonLabel={t('copy-ip-address')} copyValue={networkDevice.ipAddress} />
                                                </div>

                                                { networkDevice.deviceType.label !== 'PC' || (
                                                    <div className="flex-column my-2">
                                                        <Button
                                                            className="w-100"
                                                            variant={"outline-primary"}
                                                            onClick={() => this.handleOnClickScreenShot() }
                                                            disabled={!networkDevice.isOnline}
                                                        >
                                                            <i className="far fa-images" /> &nbsp;
                                                            {t('screenshot')}
                                                        </Button>
                                                    </div>
                                                )}

                                                { !screenShot || (
                                                    <div className="flex-column my-2">
                                                        <Button className="w-100" variant={"outline-success"} onClick={() => this.handleDownloadScreenShow()} >
                                                            <i className="fas fa-download" /> &nbsp;
                                                            {t('download-screenshot')}
                                                        </Button>
                                                    </div>
                                                ) }
                                            </div>
                                        </div>

                                        { !screenShot || (
                                            <div className='row'>
                                                <h5 className="col-md-12">{t('screenshot')}</h5>
                                                <div className="col-md-6">
                                                    <p>{t('msg.click-image-to-fullscreen')}</p>
                                                </div>
                                                <img
                                                    className="img-fluid w-100"
                                                    src={URL.createObjectURL(screenShot)}
                                                    alt='screenshot'
                                                    onClick={() => this.handleOpenFullScreen(networkDevice)}/>
                                            </div>
                                        )}

                                    </div>
                                </Tab>
                                { !networkDevice?.deviceType.label.includes("Crestron") || (
                                    <Tab eventKey="contact" title={t('crestron-settings')}>
                                        <div className="col-md-12 my-2">
                                            <p>
                                                <b>{ t('crestron-test-command') }</b>
                                            </p>

                                            <div className="row">
                                                <div className="col-md-8">
                                                    <input className="form-control" onChange={(e) => this.handleInputCrestronCommand(e)}/>
                                                </div>
                                                <div className="col-md-4">
                                                    <button className="btn btn-primary" onClick={() => this.handleButtonSendCommandCrestron() }>{t('send-test-command')}</button>
                                                </div>
                                            </div>

                                        </div>
                                    </Tab>
                                ) }

                                { !networkDevice?.deviceType.label.includes("PC") || (
                                    <Tab eventKey="contact" title={t('device-version')}>
                                        <div className="col-md-12 my-2">
                                            <p>
                                                <b>{ t('current-version') }</b>: &nbsp;
                                                { networkDevice?.hiLightSoftwareVersion || t('no-version')  }
                                            </p>

                                            <hr/>

                                            <label>{ t('update-hilight-software') }</label>
                                            { versionsList ? (
                                                <select
                                                    className="form-control"
                                                    value={selectedVersion || "none"}
                                                    onChange={this.handleOnChangeVersion}
                                                >
                                                    <option value={"none"}>{ t('no-version') }</option>
                                                    { versionsList?.map((item, idx) => {
                                                        return (<option key={idx} value={item}>{ item }</option>)
                                                    })}
                                                </select>
                                            ) : (<></>) }

                                            { selectedVersion && selectedVersion !== "none" && versionIsChanges ? (
                                                <div className="py-2">
                                                    <Alert variant={"warning"}>
                                                        { t('info-update-warning') }
                                                    </Alert>
                                                    <Button variant={"outline-success"} onClick={this.handleButtonUpdate}>
                                                        { t('btn-update') }
                                                    </Button>
                                                </div>
                                            ) : (<React.Fragment/>) }
                                        </div>
                                    </Tab>
                                ) }

                                {  !networkDevice?.details  || (
                                    <Tab eventKey="details" title={t('details')}>
                                        <div className="col-md-12 my-2">
                                            <table className="table table-sm table-borderless">
                                                <tbody>
                                                    <tr>
                                                        <th scope="col">{t('details-last-updated')}</th>
                                                        <td>{ <Moment format="YYYY/MM/DD HH:mm:ss">{ networkDetails?.lastUpdated }</Moment> }</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="col">{t('details-lamp-hours')}</th>
                                                        <td>{ networkDevice.networkDeviceDetails?.lampHours }h</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col">{t('details-pjlink-class')}</th>
                                                        <td>{ networkDevice.networkDeviceDetails?.pjLinkClass } </td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col">{t('details-current-source')}</th>
                                                        <td><pre>{ networkDevice.networkDeviceDetails?.source }</pre></td>
                                                    </tr>
                                                    <tr>
                                                    <th scope="col">{t('details-errors')}</th>
                                                        { errors ? (
                                                            <td>
                                                                <table className="table table-sm table-borderless">
                                                                    <tbody>
                                                                        <tr>
                                                                            <th scope="col">{t('fan')}</th>
                                                                            <td>{ errors?.fan || t('ok') }</td>
                                                                        </tr>

                                                                        <tr>
                                                                            <th scope="col">{t('lamp')}</th>
                                                                            <td>{ errors?.lamp || t('ok') }</td>
                                                                        </tr>

                                                                        <tr>
                                                                            <th scope="col">{t('temperature')}</th>
                                                                            <td>{ errors?.temperature || t('ok') }</td>
                                                                        </tr>

                                                                        <tr>
                                                                            <th scope="col">{t('cover')}</th>
                                                                            <td>{ errors?.cover || t('ok') }</td>
                                                                        </tr>

                                                                        <tr>
                                                                            <th scope="col">{t('filter')}</th>
                                                                            <td>{ errors?.filter || t('ok') }</td>
                                                                        </tr>

                                                                        <tr>
                                                                            <th scope="col">{t('other')}</th>
                                                                            <td>{ errors?.other || t('oj') }</td>
                                                                        </tr>

                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        ) : (
                                                            <td>brak</td>
                                                        ) }
                                                </tr>
                                                </tbody>
                                            </table>

                                        </div>
                                    </Tab>
                                )}
                            </Tabs>
                        </div>
                    </div>
                ) : (
                    <div className="modal-body">
                        <Spinner className="mx-0 " animation={"border"} />
                    </div>
                ) }

                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={closeModal}>{t('close')}</button>
                </div>
            </div>
        )
    }

}
export default withNamespaces()(DeviceInfoModal);
